import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserResponse } from '@app/store/user';
import { environment } from '@src/environments/environment';
import { GenericResponse } from '@app/models/backend/generic-response';

@Injectable({ providedIn: 'root' })
export class GeneralService {
  /** Último usuario autenticado en memoria (inyectado por NGRX u otros) */
  usuario$!: UserResponse;

  constructor(private http: HttpClient) {}

  /** Obtiene el JWT almacenado */
  getToken(): string | null {
    return localStorage.getItem('token');
  }

  /** Devuelve el id de usuario o 0 si no existe (mínimo necesario) */
  getUserId(): number {
    if (this.usuario$?.id) {
      return this.usuario$.id;
    }
    try {
      const raw = localStorage.getItem('user');
      return raw ? JSON.parse(raw).id ?? 0 : 0;
    } catch {
      return 0;
    }
  }

  /**
   * Obtiene la efectividad del equipo de asesores de un coordinador
   */
  getEfectividadEquipo(
    coordinadorId: number
  ): Observable<GenericResponse<any[]>> {
    return this.http.get<GenericResponse<any[]>>(
      `${environment.url}api/asesores/${coordinadorId}/efectividad-equipo`
    );
  }

  /**
   * Obtiene el detalle de todos los clientes de un asesor específico
   */
  getClientesDetalleAsesor(
    coordinadorId: number,
    asesorId: number,
    page: number = 0,
    size: number = 50
  ): Observable<GenericResponse<any[]>> {
    return this.http.get<GenericResponse<any[]>>(
      `${environment.url}api/asesores/${coordinadorId}/asesor/${asesorId}/clientes-detalle?page=${page}&size=${size}`
    );
  }

  obtenerEfectividadEquiposSupervisores(
    supervisorId?: number | null,
    sedeId?: number | null,
    page: number = 0,
    size: number = 10
  ): Observable<GenericResponse<any>> {
    let params = new HttpParams();
    if (supervisorId)
      params = params.set('supervisorId', supervisorId.toString());
    if (sedeId) params = params.set('sedeId', sedeId.toString());
    params = params.set('page', page.toString());
    params = params.set('size', size.toString());

    return this.http.get<GenericResponse<any>>(
      `${environment.url}api/asesores/efectividad-equipos-supervisores`,
      { params }
    );
  }
}
